<template>
	<div>
		<div style="padding: 0 0 0 300px;">
			<div class="nodea" v-if="count.length == 0">
				<img src="../../../assets/img/nodata.png" />
			</div>
			<el-card class="list_box cardheader" shadow="never" v-for="(item, index) in count" :key="index">
				<div slot="header">
					<div>
						<span>题型：{{ item.qtpye }}</span>
						<el-divider direction="vertical" style="background-color: black;"></el-divider>
						<span v-if="item.diff == '1.00'">难易度：简单</span>
						<span v-else-if="item.diff == '2.00'">难易度：一般</span>
						<span v-else-if="item.diff == '3.00'">难易度：中等</span>
						<span v-else-if="item.diff == '4.00'">难易度：困难</span>
						<span v-else-if="item.diff == '5.00'">难易度：特难</span>
					</div>
				</div>
				<div :v-html="MathJax.MathQueue(item)"></div>
				<div class="latexDiv" v-html="item.title" style="margin-top: 20px;"></div>
				<div class="li-da">
					<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_a">
						A:<span v-html="item.option_a"></span>
					</div>

					<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_b">
						B:<span v-html="item.option_b"></span>
					</div>

					<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_c">
						C:<span v-html="item.option_c"></span>
					</div>

					<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_d">
						D:<span v-html="item.option_d"></span>
					</div>
				</div>
				<el-divider style="width:100%;border:1px dashed #EBEEF5;"></el-divider>
				<div class="p_flex p_f_a p_f_b p_m_t_20">
					<div class="p_flex type_size_16"></div>
					<div class="p_flex">
						<el-button v-if="!item.isscs" type="info" plain size="mini" @click="scs(index)"
							style="background: #67C23A;color: #FFFFFF">
							加入习题篮
						</el-button>
						<el-button v-if="item.isscs" type="info" plain size="mini" @click="dele(index)"
							style="background: #67C23A;color: #FFFFFF">
							移除
						</el-button>
					</div>
				</div>
			</el-card>
			<pagination @get="get" :index="num" ref='pagination'
				style="position: fixed;bottom: 0;left: 50%;transform: translateX(-50%);" />
		</div>
	</div>
</template>

<script>
	import pagination from "../../pagination/pagination.vue";

	export default {
		props: {
			r: Boolean,
			age: String, //学段id
			ages: String, //年级id
			agess: String, //学科id
			agesss: String, //教材版本id
			agessss: Object, //知识点id
			agesssss: String, //题型id
			agessssss: String, //难易程度id
			agesssssss: Number, //时间
			agessssssss: String, //题类id
			dataList: Array,
			xz1: Number,
			tk1: Number,
			wd11: Number,
			count: Array
		},
		data() {
			return {
				//count: [], //题目列表
				num: 0,
				gradeName: "",
				subjectName: "",
				pharseId: "", //学段id
				gradeId: "", //年级id
				subjectId: "", //学科id
				editionId: "", //教材版本id
				knowledgeId: "", //知识点id
				questionTypeId: "", //题型id
				diffTypeId: "", //难易程度id
				datetime: "", //时间
				testPaperTypeId: "", //题类id
				chapterId: "",
				id: "",
				template: {}
			};
		},
		components: {
			pagination
		},
		created() {
			this.dataList = [];
			this.id = this.$route.query.id;

			//习题篮列表		obj.pharseId = this.pharseCode
			/* this.pharseId = JSON.parse(localStorage.getItem('initData')).pharseId
				this.subjectId = JSON.parse(localStorage.getItem('initData')).subjectId
				this.editionId = JSON.parse(localStorage.getItem('initData')).editionId
				this.gradeId = JSON.parse(localStorage.getItem('initData')).gradeId
				this.gradeName = JSON.parse(localStorage.getItem('gradeName'))
				this.subjectName = JSON.parse(localStorage.getItem('subjectName')) */
			// this.diffTypeId = JSON.parse(localStorage.getItem('initData')).diffTypeId
			// this.testPaperTypeId = JSON.parse(localStorage.getItem('initData')).paperType
			//this.knowledgeId = JSON.parse(localStorage.getItem('initData')).knowledgeId
			//this.get()
		},
		mounted() {},
		watch: {
			r: {
				handler() {
					this.getDataList();
				}
			},
			age: {
				handler(i) {
					this.pharseId = i; //学段id
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			ages: {
				handler(i) {
					this.gradeId = i; //年级id
					this.gradeName = JSON.parse(localStorage.getItem("gradeName"));
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agess: {
				handler(i) {
					this.subjectId = i; //学科id
					this.subjectName = JSON.parse(
						localStorage.getItem("subjectName")
					);
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agesss: {
				handler(i) {
					this.editionId = i; //教材版本id
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agessss: {
				handler(item) {
					console.log(item);
					this.knowledgeId = item.knowledgeId; //知识点id
					this.chapterId = item.chapterId;
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agesssss: {
				handler(i) {
					this.questionTypeId = i; //题型id
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agessssss: {
				handler(i) {
					this.diffTypeId = i; //难易程度id
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agesssssss: {
				handler(i) {
					this.datetime = i; //时间
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			agessssssss: {
				handler(i) {
					this.testPaperTypeId = i; //题类id
					this.get(1);

					this.$refs.pagination.handleCurrentChange(1)
				}
			},
			count: {
				handler(i) {
					this.count = i;
				}
			}
		},
		methods: {
			//删除已选
			dele(index) {
				console.log(this.count);
				debugger
				this.dataList.forEach((value1, index2) => {
					if (value1.id == this.count[index].id) {
						var typeName = this.count[index].qtpye;
						if (
							typeName.includes("选择") ||
							typeName.includes("单选") ||
							typeName.includes("多选")
						) {
							this.xz1--;
						} else if (
							typeName.includes("填空") ||
							typeName.includes("单空") ||
							typeName.includes("判断")
						) {
							this.tk1--;
						} else {
							this.wd1--;
						}

						this.dataList.splice(index2, 1);
						this.$message({
							message: "移除成功！",
							type: "success"
						});
					}
				});
				this.$emit("update:dataList", this.dataList);
				//this.$set(this.dataList[index], 'isscs', false)
				this.$emit("update:xz1", this.xz1);
				this.$emit("update:tk1", this.tk1);
				this.$emit("update:wd1", this.wd1);
				this.$set(this.count[index], "isscs", false);
				this.$emit("update:count", this.count);
				this.$forceUpdate();
			},
			deleP(item) {
				console.log(this.count);

				this.count.forEach((value, index) => {
					if (value.id == item.id) {
						this.dataList.forEach((value1, index2) => {
							if (value1 == this.count[index]) {
								var typeName = this.count[index].qtpye;
								if (
									typeName.includes("选择") ||
									typeName.includes("单选") ||
									typeName.includes("多选")
								) {
									this.xz1--;
								} else if (
									typeName.includes("填空") ||
									typeName.includes("单空") ||
									typeName.includes("判断")
								) {
									this.tk1--;
								} else {
									this.wd1--;
								}

								this.dataList.splice(index2, 1);
								this.$message({
									message: "移除成功！",
									type: "success"
								});
							}
						});
						this.$emit("update:dataList", this.dataList);
						//this.$set(this.dataList[index], 'isscs', false)
						this.$emit("update:xz1", this.xz1);
						this.$emit("update:tk1", this.tk1);
						this.$emit("update:wd1", this.wd1);
						this.$set(this.count[index], "isscs", false);
						this.$emit("update:count", this.count);
						this.$forceUpdate();
					}
				});
			},
			//加入习题篮
			scs(index) {
				if (sessionStorage.getItem("template") == "noTemplate") {
					this.template = "noTemplate";
				} else {
					this.template = JSON.parse(sessionStorage.getItem("template"));
				}

				let i = 0;
				if (this.dataList.length > 0) {
					this.dataList.forEach((value1, index2) => {
						if (value1.subjectId != this.count[index].subjectId) {
							this.$message({
								showClose: true,
								message: "不可添加其他学科！",
								type: "warning"
							});
							i++;
						}
					});
				}
				if (i == 0) {
					if (this.template != "noTemplate") {
						var typeName = this.count[index].qtpye;
						if (
							typeName.includes("选择") ||
							typeName.includes("单选") ||
							typeName.includes("多选")
						) {
							var a = this.xz1 + 1;
							if (a > this.template.xz) {
								this.$message({
									message: "选择数量已满！",
									type: "error"
								});

								return;
							} else {
								this.xz1++;
							}
						} else if (
							typeName.includes("填空") ||
							typeName.includes("单空") ||
							typeName.includes("判断")
						) {
							var a = this.tk1 + 1;
							if (a > this.template.tk) {
								this.$message({
									message: "填空数量已满！",
									type: "error"
								});

								return;
							} else {
								this.tk1++;
							}
						} else {
							var a = this.wd1 + 1;
							if (a > this.template.wd) {
								this.$message({
									message: "问答数量已满！",
									type: "error"
								});

								return;
							} else {
								this.wd1++;
							}
						}
					} else {
						var typeName = this.count[index].qtpye;
						if (
							typeName.includes("选择") ||
							typeName.includes("单选") ||
							typeName.includes("多选")
						) {
							this.xz1++;
						} else if (
							typeName.includes("填空") ||
							typeName.includes("单空") ||
							typeName.includes("判断")
						) {
							this.tk1++;
						} else {
							this.wd1++;
						}
					}

					this.dataList.push(this.count[index]);

					let newArray = JSON.parse(JSON.stringify(this.dataList));

					// newArray.push(this.count[index]);

					// newArray.forEach(value => {
					// 	if (
					// 		this.subjectName == "语文" ||
					// 		this.subjectName == "英语"
					// 	) {
					// 		value.knowledge_id = this.chapterId;
					// 	} else {
					// 		value.knowledge_id = this.knowledgeId;
					// 	}

					// 	value.qtpye_id = this.questionTypeId;
					// 	value.paperTpye = this.testPaperTypeId;
					// });

					for (let i = 0; i < newArray.length; i++) {
						if (
							this.subjectName == "语文" ||
							this.subjectName == "英语"
						) {
							newArray[i].knowledge_id = this.chapterId;
						} else {
							newArray[i].knowledge_id = this.knowledgeId;
						}

						newArray[i].qtpye_id = this.questionTypeId;
						newArray[i].paperTpye = this.testPaperTypeId;
					}

					// for (let i = 0; i < newArray.length; i++) {
					// 	newArray[i].paperTpye = this.testPaperTypeId;
					// }

					// this.dataList = newArray;

					this.$emit("update:dataList", newArray);
					this.$emit("update:xz1", this.xz1);
					this.$emit("update:tk1", this.tk1);
					this.$emit("update:wd1", this.wd1);
					this.$set(this.count[index], "isscs", true);
					this.$emit("update:count", this.count);
					this.$forceUpdate();
					this.$message({
						message: "加入成功！",
						type: "success"
					});
				} else {
					i = 0;
				}
			},
			//获取列表数据
			get(id) {
				if (this.knowledgeId != "" || this.chapterId != "") {
					this.$request
						.ajax(this)
						.post("/HuiApiRequest/getQuestionDataByKnowledgeId", {
							page: id ? id : 1, //第几页
							datacount: 10, //，每页显示
							year: this.datetime, //时间
							diff: this.diffTypeId,
							paperType: this.testPaperTypeId,
							qtypeId: this.questionTypeId,
							knowledgeId: this.knowledgeId,
							chapterId: this.chapterId
						})
						.then(res => {
							if (typeof res == "object") {
								if (res.status == 0) {
									this.count = res.data;
								}
							}

							this.count = JSON.parse(res).data;
							if (this.count.length > 0) {
								this.count.forEach(value => {
									value.isscs = false;
								});
								this.num = parseInt(JSON.parse(res).dataCount);
							}

							this.$emit("update:count", this.count);
						});
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.list_box {
		//padding: 20px 0;
		border: 1px solid #ebeef5;
		margin: 0 20px;
		margin-bottom: 10px;
		font-size: 15px;
		line-height: 50px;
		//text-align:center;
	}

	.el-divider--vertical {
		display: inline-block;
		width: 1px;
		height: 1em;
		margin: 0 8px;
		vertical-align: middle;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/huiSheet.vue